import React from "react";
import ReactModal from "react-modal";
import "./index.scss";
import { Loader } from "rsuite";

class CopyApplicationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dba: props?.appData?.field_dba ? props?.appData?.field_dba : "",
            error: "",
        };
    }

    handleChange(e) {
        this.setState({
            dba: e.target.value,
            error: "",
        });
    }

    handleSubmit() {
        if (this.state.dba !== "") {
            this.props.handConfirm(this.state.dba);
        } else {
            this.setState({
                error: "Please fill DBA",
            });
        }
    }

    render() {
        return (
            <ReactModal
                isOpen={this.props.isOpen}
                className="copy-application-modal"
            >
                <div>
                    <div className="modal-header">
                        <h4 className="text-left">Copy Application</h4>
                    </div>
                    <div className="modal-body">
                        <div>
                            <div className="form-group">
                                <label htmlFor="dba">DBA</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="dba"
                                    id="dba"
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.dba}
                                />
                                <p className="error-message">
                                    {this.state.error}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn cancel-button"
                            onClick={() => this.props.handleClose()}
                        >
                            No
                        </button>
                        {this.props.showLoader ? (
                            <button className="btn confirm-button">
                                <Loader />
                            </button>
                        ) : (
                            <button
                                className="btn confirm-button"
                                onClick={() => this.handleSubmit()}
                            >
                                Confirm
                            </button>
                        )}
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default CopyApplicationModal;
